export default "const fun1 = function (arg1) {\n}\nconst fun2 = function(arg1) {\n}\n"